import React from 'react';
import { FormattedMessage } from 'react-intl';

const translation = (id: string, value: object = {}) => (
  <FormattedMessage id={id} values={{ ...value }} />
);

export default translation;
